<div class="pill">
  <img *ngIf="icon" [src]="icon" alt="" />
  <span>{{ label }}</span>
</div>
